<template>
  <b-input
    :icon="!iconRight ? 'magnify' : ''"
    :iconRight="iconRight ? 'magnify' : ''"
    :value="value"
    :placeholder="$t('search')"
    :class="[
      '[&>.icon]:w-24px [&>.icon]:hover:text-primary-10 [&>.icon]:text-gray-5 color-regular-grey',
      {
        '[&>.icon]:!text-primary-10': isFocus,
        '[&>.icon]:h-32px': size === 32,
        '[&>.icon]:h-40px': size === 40,
        '[&>.icon]:right-16px': iconRight,
        '[&>.icon]:left-16px': !iconRight,
      },
    ]"
    :customClass="customClassStr"
    @focus="isFocus = true"
    @blur="isFocus = false"
    @input="(value) => (needDebounce ? debounceSearch(value) : onSearch(value))"
    @keyup.enter.native="onEnter"
  />
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'BaseSearch',
  props: {
    iconRight: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onEnter: {
      type: Function,
      default: () => {},
    },
    needDebounce: {
      type: Boolean,
      default: () => true,
    },
    inputClass: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 32,
    },
  },
  data() {
    return {
      isFocus: false,
    }
  },
  computed: {
    customClassStr() {
      const baseClasses =
        'rounded-24 border-solid border-1 border-regular-grey focus:border-bright-sky-blue-two focus:shadow-none hover:border-bright-sky-blue-two hover:shadow-none'
      const sizeClasses = this.size === 32 ? 'h-32px' : 'h-40px'
      const spacingClasses = this.iconRight ? 'pl-16px' : 'pl-48px'
      return `${baseClasses} ${sizeClasses} ${spacingClasses} ${this.inputClass || ''}`
    },
  },
  methods: {
    debounceSearch: debounce(function (value) {
      this.$emit('input', value)
      this.onChange(value)
    }, 500),
    onSearch(value) {
      this.$emit('input', value)
      this.onChange(value)
    },
  },
}
</script>
